import BaseField, { FieldDefined, FieldTypeDefined } from '@/libs/fieldModule/fieldInterface'

import { TableColTriggerUpdate, TableColTypeDef } from './type'

/**
 * module通用的基类函数
 * @param name
 * @param fieldDefined
 * @returns
 */
export default function createModule<T extends BaseField<FieldDefined<B>>, B extends FieldTypeDefined> (
  FieldDefined:any,
  name?:string
) {
  function render (item:any, triggerUpdate:TableColTriggerUpdate) {
    const field = item.key
    const oldRender = item.render
    const moduleField = new FieldDefined(item) as T
    item.render = (h:any, params:any, editable:boolean, placeholder:string) => {
      const value = params.row[field]
      if (!editable) {
        if (oldRender) {
          return oldRender(h, params)
        }
        return moduleField.renderField(h, value, params.row)
      }
      return moduleField.renderEditField(h, value, (newValue:any) => {
        triggerUpdate(field, params, newValue)
        if (item.type.onChange) {
          item.type.onChange(params.row)
        }
      }, placeholder, params.row)
    }
    if (item.width === undefined) {
      item.width = moduleField.getFieldWidth()
    }
    if (item.minWidth === undefined) {
      item.minWidth = moduleField.getFieldMinWidth()
    }
    return item
  }

  return {
    name: name || FieldDefined.getModuleName(),
    render
  } as TableColTypeDef
}
